import {
  ACTION_SHIPPING,
  PARAMETER_COUPON,
  PARAMETER_DISPLAYITEMSKU,
  PARAMETER_PRICESVCURL,
  PARAMETER_REFID,
  PARAMETER_SAMPLE,
  PARAMETER_STATUS,
  PARAMETER_TEMPLATEID,
  PARAMETER_TOKEN,
  PARAMETER_VENDORID,
  configuratorStep,
  studioItemType,
} from "../main/constants";
import { addArtForLite, clearImageDict, setImageUI } from "../canvas/actions";
import {
  addBackupsForLiteParentChildItem,
  changeInitializedImprintAreaKeys,
  hideWaitingCover,
  initializeActiveCart,
  initializeBomPreview,
  initializeCharges,
  initializeImprintAreaDimension,
  initializeItemSpec,
  initializeOrder,
  initializeSaveProject,
  initializeShipping,
  initializeTrackingPixelScript,
  initializeUser,
  initializeVendor,
  setAllDataLoadedForLite,
  setCurrentImprintAreaKey,
  setCurrentStep,
  setPrevLiteSharedArtColorsDict,
  setPrevLiteSharedArtDict,
  showMessageBox,
  showWaitingCover,
} from "../main/actions";
import {
  catchErrorForInitializeCart,
  catchErrorInfo,
  validateResultForEditing,
} from "../main/logics";
import {
  changeLogoColorAsync,
  getAllSelectedImprintAreaKeysFromImprintAreasCombinedDict,
  getDefaultColor,
  imprintAreasInitAsync,
  imprintColorInitAsync,
  imprintOptionAssembleAsync,
  logoLayoutInitAsync,
  textLayoutInitAsync,
} from "../imprintarea/logics";
import { colorSpace, elementStatus } from "../utils/constants";
import { colorizeCheckColor, getAdjustSize } from "../userimage/logics";
import {
  getBackupByChildItemId,
  getChildItemIdFromBomSelectionForLite,
  getIsExistInBackups,
  getIsLiteParentChildItem,
  getPrevLiteSharedArtColorsDict,
  getPrevLiteSharedArtDict,
  getSharedArtColors,
  getSharedArtsForComponentId,
  getSharedColorsForComponentId,
} from "./selectors";
import {
  getLiteCartData,
  getLiteData,
  getLiteMainItemData,
  getLiteSharedArtData,
} from "./apis";
import {
  getLiteHasVignette,
  getSelectedColorBomOptions,
} from "../preview/selectors";
import {
  getParameters,
  getReturnUrl,
  getStudioItemType,
} from "../main/selectors";
import {
  imprintAreasCombinedInit,
  imprintAreasInit,
  imprintOptionTypeInit,
} from "../imprintarea/actions";
import { initNonDigitalText, initNonDigitalTextLine } from "../text/actions";
import {
  initializeChildOptions,
  initializeQuantity,
  initializeQuestions,
  initializeRelations,
  initializeSizeChart,
  initializeUniqueOptions,
  initializeUniqueOptionsBackup,
} from "../bom/actions";
import {
  initializeLiteSharedArtColors,
  initializeLiteSharedArts,
  initializeLiteTextColors,
  initializeSharedArtColors,
} from "./actions";
import {
  invalidCharactersRetrieval,
  updateNonDigitalFullPreview,
} from "../text/logics";

import { addInitImageElements } from "../canvas/actions";
import { clearSharedArtDict } from "../userimage/actions";
import { getCanvasDraggingArea } from "../canvas/selectors";
import { getFarthestColorApi } from "../imprintarea/api";
import { getFirstSelectedColorBomOption } from "../bom/selectors";
import { getImprintAreasInit } from "../imprintarea/selectors";
import { getNonDigitalTextDict } from "../text/selectors";
import { push as go } from "redux-first-history";
import { initializeInventories } from "../inventories/actions";
import { initializeSharedArt } from "../userimage/logics";
import { objectDeepEqual } from "../utils/index";
import price from "../price";
import { setLogoEditingStatusToPreview } from "../uploadimage/logics";

export const initializeLiteData =
  (sharedArtRequest, liteRequest, isLiteParentChildItem, childItemId) =>
  (dispatch) => {
    return Promise.all([
      getLiteSharedArtData(sharedArtRequest),
      getLiteData(liteRequest),
    ])
      .then((response) => {
        const sharedArtsResponse = response[0].data;
        const preConfigResponse = response[1].data;
        if (preConfigResponse.item.inventoryStatus !== "N") {
          dispatch(
            setLiteData(
              sharedArtsResponse,
              preConfigResponse,
              isLiteParentChildItem
            )
          );
          if (isLiteParentChildItem) {
            const backup = {
              key: childItemId,
              value: {
                sharedArtsResponse,
                preConfigResponse,
              },
            };
            dispatch(addBackupsForLiteParentChildItem(backup));
          }
        } else {
          dispatch(hideWaitingCover());
          dispatch(
            showMessageBox({
              show: true,
              message: "This item is obsoleted and not sold anymore",
              hasCloseButton: false,
              onOk: () => {
                dispatch(go(-1));
              },
            })
          );
        }
      })
      .catch((error) => {
        dispatch(catchErrorInfo(error));
        dispatch(setCurrentStep(configuratorStep.error));
        dispatch(hideWaitingCover());
      });
  };

const setLiteData =
  (sharedArtsResponse, preConfigResponse, isLiteParentChildItem) =>
  (dispatch) => {
    dispatch(initializeVendor(preConfigResponse.vendor));
    !isLiteParentChildItem &&
      dispatch(initializeItemSpec(preConfigResponse.item));
    dispatch(price.actions.initializePrice(preConfigResponse.price));
    dispatch(initializeCharges(preConfigResponse.charges));
    dispatch(imprintOptionTypeInit(preConfigResponse.imprintOptionType));
    dispatch(textLayoutInitAsync(preConfigResponse.imprintLocations));
    dispatch(logoLayoutInitAsync(preConfigResponse.logoLocations));
    dispatch(
      imprintAreasInitAsync({
        imprintFormats: preConfigResponse.imprintFormats,
        imprintGroups: preConfigResponse.imprintGroups,
      })
    );
    dispatch(imprintColorInitAsync(preConfigResponse.imprintColor));
    dispatch(initializeActiveCart(preConfigResponse.activeCart));
    if (!isLiteParentChildItem) {
      dispatch(initializeChildOptions(preConfigResponse.childQuestionOptions));
      dispatch(initializeRelations(preConfigResponse.questionRelations));
      dispatch(
        initializeUniqueOptions(preConfigResponse.questionUniqueOptions)
      );
      dispatch(
        initializeUniqueOptionsBackup(preConfigResponse.questionUniqueOptions)
      );
      dispatch(initializeQuestions(preConfigResponse.questions));
      dispatch(initializeSizeChart(preConfigResponse.sizeChart));
      dispatch(initializeInventories(preConfigResponse.inventories));
      dispatch(
        initializeTrackingPixelScript(preConfigResponse.trackingPixelScript)
      );
      dispatch(initializeBomPreview(preConfigResponse.bomPreview));
      dispatch(initializeUser(preConfigResponse.user));
      dispatch(initializeShipping(preConfigResponse.shipping));
    }
    dispatch(
      initializeImprintAreaDimension(preConfigResponse.imprintAreaDimension)
    );
    let selectedImprintKeys =
      getAllSelectedImprintAreaKeysFromImprintAreasCombinedDict(
        preConfigResponse.imprintGroups
      );
    dispatch(setCurrentImprintAreaKey(selectedImprintKeys[0]));
    dispatch(changeInitializedImprintAreaKeys(selectedImprintKeys));

    dispatch(initNonDigitalText(preConfigResponse.text));
    dispatch(initNonDigitalTextLine(preConfigResponse.textLine));
    dispatch(initializeLiteTextColors(preConfigResponse.textColors));
    dispatch(invalidCharactersRetrieval({ fromLiteText: true }));
    dispatch(
      updateNonDigitalFullPreview({
        updatePreviewsForAll: true,
        needUpdatePreview: true,
      })
    );

    dispatch(initializeLiteSharedArts(sharedArtsResponse.sharedArts));
    dispatch(initializeLiteSharedArtColors(sharedArtsResponse.sharedArtColors));
    dispatch(setSharedArtColors());
    dispatch(setSharedArt());
    dispatch(setAllDataLoadedForLite(true));
    dispatch(setCurrentStep(configuratorStep.lite));
    dispatch(hideWaitingCover());
  };
export const setSharedArt = () => (dispatch, getState) => {
  let currentSharedArtListDict = {};
  const state = getState();
  const sharedArtsForComponentId = getSharedArtsForComponentId(state);
  for (let imprintAreaKey in sharedArtsForComponentId) {
    const sharedArtList = sharedArtsForComponentId[imprintAreaKey];
    currentSharedArtListDict[imprintAreaKey] = sharedArtList;
    dispatch(initializeSharedArt(sharedArtList, imprintAreaKey));
  }
  dispatch(setPrevLiteSharedArtDict(currentSharedArtListDict));
};

export const setSharedArtColors = () => (dispatch, getState) => {
  let currentSharedArtColorsDict = {};
  const state = getState();
  const sharedArtColorsForComponentId = getSharedColorsForComponentId(state);
  for (let imprintAreaKey in sharedArtColorsForComponentId) {
    const color = sharedArtColorsForComponentId[imprintAreaKey];
    currentSharedArtColorsDict[imprintAreaKey] = color;
    dispatch(initializeSharedArtColors({ imprintAreaKey, color }));
  }
  dispatch(setPrevLiteSharedArtColorsDict(currentSharedArtColorsDict));
};

const sharedArtDefaultColorize =
  ({ currentImprintAreaKey, watchGuid, sharedArt }) =>
  (dispatch, getState) => {
    const state = getState();
    const nonDigitalTextDict = getNonDigitalTextDict(state);
    const sharedArtColors = getSharedArtColors(
      state,
      currentImprintAreaKey,
      sharedArt
    );
    const nonDigitalTextList =
      nonDigitalTextDict && nonDigitalTextDict[currentImprintAreaKey];
    const textColor =
      nonDigitalTextList.length > 0 && nonDigitalTextList[0].data.color;
    const hasTextColor = sharedArtColors.some(
      (color) => color.colorId === textColor.colorId
    );
    const colorize = (defaultColor) => {
      if (defaultColor) {
        const colors = [defaultColor];
        dispatch(
          setImageUI({
            type: "colorize_img",
            canvasKey: currentImprintAreaKey,
            guid: watchGuid,
            ui: {
              canEdit: true,
              topColorCount: 1,
            },
            data: { colors },
          })
        );

        dispatch(
          changeLogoColorAsync({
            formatkey: currentImprintAreaKey,
            guid: watchGuid,
            colors,
          })
        );
      }
    };
    if (hasTextColor) {
      colorize(textColor);
    } else {
      const request = {
        colorList: sharedArtColors,
        colorReference: (
          getSelectedColorBomOptions(state)[0]?.colorReference ||
          getFirstSelectedColorBomOption(state)?.colorReference ||
          ""
        ).replace("#", ""),
      };
      getFarthestColorApi(request).then((res) => {
        if (res && res.data) colorize(res.data);
        else colorize(getDefaultColor(sharedArtColors));
      });
    }
  };

const sharedArtColorize =
  ({ currentImprintAreaKey, sharedArt, watchGuid, callback }) =>
  (dispatch, getState) => {
    //colorSpace from DAM Service, we can use it directly
    if (sharedArt.colorSpace === colorSpace.MultipleColor) {
      const state = getState();
      const sharedArtColor = getSharedArtColors(
        state,
        currentImprintAreaKey,
        sharedArt
      );
      if (sharedArtColor.length === 0) {
        dispatch(
          colorizeCheckColor({
            studioType: studioItemType.nonDigital,
            formatkey: currentImprintAreaKey,
            imageData: sharedArt,
            onComplete: (colors) => {
              if (colors && colors.length > 0) {
                //just record colorize colors
                //show Show original(DO NOT COLORIZE) sharedArt
                dispatch(
                  changeLogoColorAsync({
                    formatkey: currentImprintAreaKey,
                    guid: watchGuid,
                    colors,
                  })
                );
                dispatch(
                  setImageUI({
                    type: "colorize_shared",
                    canvasKey: currentImprintAreaKey,
                    guid: watchGuid,
                    ui: {
                      canEdit: false,

                      topColorCount: colors.length,
                    },
                  })
                );
              } else {
                /**
                 *    nothing to do,
                 *    has get default ImprintColor after SharedArt Thumbnail click
                 */
                dispatch(
                  sharedArtDefaultColorize({
                    currentImprintAreaKey,
                    watchGuid,
                    sharedArt,
                  })
                );
              }
              callback && callback();
            },
          })
        );
      } else {
        dispatch(
          changeLogoColorAsync({
            formatkey: currentImprintAreaKey,
            guid: watchGuid,
            colors: sharedArtColor,
          })
        );
        callback && callback();
      }
    } else {
      /**
       * SingleColor ColorSpace SharedArt
       * nothing to do,
       * has get default ImprintColor after SharedArt Thumbnail click
       */
      dispatch(
        sharedArtDefaultColorize({
          currentImprintAreaKey,
          watchGuid,
          sharedArt,
        })
      );
      callback && callback();
    }
  };

export const sharedArtSelectedAsync =
  (sharedArt, currentImprintAreaKey) => (dispatch, getState) => {
    const state = getState();
    const hasVignette = getLiteHasVignette(state);
    const draggingArea = getCanvasDraggingArea(state);

    const newArt = {
      data: {},
      ui: {
        guid: sharedArt.guid,
        status: elementStatus.SingleSelected,
        design: false,
      },
    };
    Object.assign(newArt.data, sharedArt);
    delete newArt.data.guid;
    const hasOriginalSize =
      sharedArt.originalWidth !== "undefined" &&
      sharedArt.originalWidth > 0 &&
      sharedArt.originalHeight !== "undefined" &&
      sharedArt.originalHeight > 0;
    if (hasOriginalSize) {
      let newSize = {};
      newSize = getAdjustSize(
        sharedArt.originalWidth,
        sharedArt.originalHeight,
        draggingArea
      );
      newArt.data.width = newSize.width;
      newArt.data.height = newSize.height;
    }
    dispatch(
      addArtForLite({
        currentImprintAreaKey: currentImprintAreaKey,
        artData: newArt,
      })
    );
    dispatch(
      sharedArtColorize({
        currentImprintAreaKey,
        sharedArt,
        watchGuid: sharedArt.guid,
        callback: () => {
          if (hasVignette) {
            dispatch(invalidCharactersRetrieval({ fromLiteText: true }));
            dispatch(
              updateNonDigitalFullPreview({
                updatePreviewsForAll: true,
                needUpdatePreview: true,
              })
            );
          }
        },
      })
    );
  };
export const imprintColorSelectedAsync =
  (color, currentImprintAreaKey, currentSelectedImage) =>
  (dispatch, getState) => {
    const state = getState();
    const hasVignette = getLiteHasVignette(state);

    dispatch(
      changeLogoColorAsync(
        {
          formatkey: currentImprintAreaKey,
          guid: currentSelectedImage && currentSelectedImage.ui.guid,
          colors: [color],
        },
        () => {
          if (hasVignette) {
            dispatch(invalidCharactersRetrieval({ fromLiteText: true }));
            dispatch(
              updateNonDigitalFullPreview({
                updatePreviewsForAll: true,
                needUpdatePreview: true,
              })
            );
          }
        }
      )
    );
  };
const getValidCartImage = (state, cartImage) => {
  const image = {};
  for (let key in cartImage) {
    if (
      state.sharedArtDict[key] &&
      state.sharedArtDict[key].some(
        (art) => art.scene7FileName === cartImage[key][0]?.scene7FileName
      )
    ) {
      image[key] = cartImage[key];
    }
  }
  return image;
};
export const initializeLiteCartData = (sharedArtRequest, cartQueryRequest) => {
  return (dispatch, getState) => {
    return Promise.all([
      getLiteSharedArtData(sharedArtRequest),
      getLiteCartData(cartQueryRequest),
    ])
      .then((response) => {
        let store = getState();
        const returnUrl = getReturnUrl(store);

        const initializeAllLiteCartData = () => (dispatch) => {
          dispatch(initializeVendor(response[1].data.vendor));
          dispatch(initializeItemSpec(response[1].data.item));
          dispatch(price.actions.initializePrice(response[1].data.price));
          dispatch(initializeCharges(response[1].data.charges));
          dispatch(imprintOptionTypeInit(response[1].data.imprintOptionType));
          dispatch(textLayoutInitAsync(response[1].data.imprintLocations));
          dispatch(logoLayoutInitAsync(response[1].data.logoLocations));
          dispatch(
            imprintAreasLiteInitAsync({
              imprintFormats: response[1].data.imprintFormats,
              imprintGroups: response[1].data.imprintGroups,
            })
          );

          dispatch(imprintColorInitAsync(response[1].data.imprintColor));
          dispatch(
            initializeChildOptions(response[1].data.childQuestionOptions)
          );
          dispatch(initializeRelations(response[1].data.questionRelations));
          dispatch(
            initializeUniqueOptions(response[1].data.questionUniqueOptions)
          );
          dispatch(
            initializeUniqueOptionsBackup(
              response[1].data.questionUniqueOptions
            )
          );
          dispatch(initializeQuestions(response[1].data.questions));
          dispatch(initializeQuantity(response[1].data.totalQuantity));
          dispatch(initializeSizeChart(response[1].data.sizeChart));
          dispatch(initializeInventories(response[1].data.inventories));
          dispatch(
            initializeTrackingPixelScript(response[1].data.trackingPixelScript)
          );
          dispatch(initializeBomPreview(response[1].data.bomPreview));
          dispatch(initializeUser(response[1].data.user));
          dispatch(initializeSaveProject(response[1].data.saveProject));
          dispatch(initializeLiteSharedArts(response[0].data.sharedArts));
          dispatch(
            initializeLiteSharedArtColors(response[0].data.sharedArtColors)
          );
          dispatch(initializeActiveCart(response[1].data.activeCart));
          dispatch(setSharedArtColors());
          dispatch(setSharedArt());
          const image = getValidCartImage(getState(), response[1].data.image);
          dispatch(
            imprintOptionAssembleAsync({
              operation: response[1].data.operation,
              imprintLocationsDict: response[1].data.imprintLocations,
              logoLocationsDict: response[1].data.logoLocations,
              textDict: response[1].data.text,
              imageDict: image,
            })
          );
          const studioItemType = getStudioItemType(getState(store));
          dispatch(
            addInitImageElements({
              studioType: studioItemType,
              imageDict: image,
              imprintAreaDict: getState().imprintAreaDict,
            })
          );
          setLogoEditingStatusToPreview(studioItemType, image, dispatch);
          dispatch(initializeOrder(response[1].data.order));
          dispatch(initializeShipping(response[1].data.shipping));
          let selectedImprintKeys =
            getAllSelectedImprintAreaKeysFromImprintAreasCombinedDict(
              response[1].data.imprintGroups
            );
          dispatch(setCurrentImprintAreaKey(selectedImprintKeys[0]));
          dispatch(changeInitializedImprintAreaKeys(selectedImprintKeys));

          dispatch(
            initializeImprintAreaDimension(
              response[1].data.imprintAreaDimension
            )
          );
          dispatch(initNonDigitalText(response[1].data.text));
          dispatch(initNonDigitalTextLine(response[1].data.textLine));
          dispatch(initializeLiteTextColors(response[1].data.textColors));
          dispatch(invalidCharactersRetrieval({ fromLiteText: true }));
          dispatch(
            updateNonDigitalFullPreview({
              updatePreviewsForAll: true,
              needUpdatePreview: true,
            })
          );

          dispatch(setAllDataLoadedForLite(true));

          cartQueryRequest.status.toLowerCase() !== ACTION_SHIPPING
            ? dispatch(setCurrentStep(configuratorStep.lite))
            : dispatch(setCurrentStep(configuratorStep.shipping));
        };
        dispatch(
          validateResultForEditing(
            cartQueryRequest,
            response[1],
            returnUrl,
            initializeAllLiteCartData
          )
        );
        dispatch(hideWaitingCover());
      })
      .catch((error) => {
        dispatch(catchErrorForInitializeCart(error));
      });
  };
};

export const imprintAreasLiteInitAsync = (res) => (dispatch) => {
  if (res.imprintFormats !== undefined) {
    dispatch(imprintAreasInit({ formats: res.imprintFormats }));
  }
  if (res.imprintGroups !== undefined) {
    dispatch(imprintAreasCombinedInit({ groups: res.imprintGroups }));
  }
};

export const initializeLiteBomOptionsData = (step1Request) => {
  return (dispatch) => {
    return getLiteMainItemData(step1Request)
      .then(function (response) {
        if (response.data.item.inventoryStatus !== "N") {
          dispatch(initializeVendor(response.data.vendor));
          dispatch(initializeItemSpec(response.data.item));
          dispatch(initializeChildOptions(response.data.childQuestionOptions));
          dispatch(initializeRelations(response.data.questionRelations));
          dispatch(
            initializeUniqueOptions(response.data.questionUniqueOptions)
          );
          dispatch(
            initializeUniqueOptionsBackup(response.data.questionUniqueOptions)
          );
          dispatch(initializeQuestions(response.data.questions));
          dispatch(initializeSizeChart(response.data.sizeChart));
          dispatch(initializeInventories(response.data.inventories));
          dispatch(
            initializeTrackingPixelScript(response.data.trackingPixelScript)
          );
          dispatch(initializeBomPreview(response.data.bomPreview));
          dispatch(initializeUser(response.data.user));
          dispatch(initializeShipping(response.data.shipping));
          dispatch(setCurrentStep(configuratorStep.lite));
          dispatch(hideWaitingCover());
          dispatch(fetchItemDataIfNeededForLite());
        } else {
          dispatch(hideWaitingCover());
          dispatch(
            showMessageBox({
              show: true,
              message: "This item is obsoleted and not sold anymore",
              hasCloseButton: false,
              onOk: () => {
                dispatch(go(-1));
              },
            })
          );
        }
      })
      .catch(function (error) {
        dispatch(catchErrorInfo(error));
        dispatch(setCurrentStep(configuratorStep.error));
        dispatch(hideWaitingCover());
      });
  };
};

export const fetchItemDataIfNeededForLite = () => {
  return (dispatch, getState) => {
    const state = getState();
    const isLiteParentChildItem = getIsLiteParentChildItem(state);
    const childItemId = getChildItemIdFromBomSelectionForLite(state);

    if (isLiteParentChildItem) {
      if (!childItemId) return;
      const parameters = getParameters(state);
      let childItemRequest = {
        vendorId: parameters[PARAMETER_VENDORID],
        itemId: childItemId,
        priceSvcUrl: parameters[PARAMETER_PRICESVCURL],
        token: parameters[PARAMETER_TOKEN],
        coupon: parameters[PARAMETER_COUPON],
        displayItemSku: parameters[PARAMETER_DISPLAYITEMSKU],
        isSample: parameters[PARAMETER_SAMPLE],
        templateId: parameters[PARAMETER_TEMPLATEID],
        status: parameters[PARAMETER_STATUS],
        refId: parameters[PARAMETER_REFID],
      };
      let sharedArtRequest = {
        vendorId: parameters[PARAMETER_VENDORID],
        itemId: childItemId,
      };
      dispatch(showWaitingCover());
      dispatch(clearImageDict());
      dispatch(clearSharedArtDict());
      const isExistInBackups = getIsExistInBackups(state);
      const backup = getBackupByChildItemId(state);
      if (!isExistInBackups) {
        dispatch(
          initializeLiteData(
            sharedArtRequest,
            childItemRequest,
            isLiteParentChildItem,
            childItemId
          )
        );
      } else {
        dispatch(
          setLiteData(
            backup.sharedArtsResponse,
            backup.preConfigResponse,
            isLiteParentChildItem
          )
        );
      }
    } else {
      const sharedArtsForComponentId = getSharedArtsForComponentId(state);
      const sharedColorsForComponentId = getSharedColorsForComponentId(state);
      const prevLiteSharedArtDict = getPrevLiteSharedArtDict(state);
      const prevLiteSharedArtColorsDict = getPrevLiteSharedArtColorsDict(state);
      if (
        !objectDeepEqual(prevLiteSharedArtDict, sharedArtsForComponentId) ||
        !objectDeepEqual(
          prevLiteSharedArtColorsDict,
          sharedColorsForComponentId
        )
      ) {
        dispatch(clearImageDict());
        dispatch(clearSharedArtDict());
        dispatch(setSharedArt());
        dispatch(setSharedArtColors());
      }
    }
  };
};
export const validateLiteImprintAreaSelected = () => (dispatch, getState) => {
  const state = getState();
  const { groups } = getImprintAreasInit(state);
  let isSelected = false;
  const allGroupKeys = Object.keys(groups);
  if (
    allGroupKeys.every((key) =>
      groups[key].combinations.some((com) => com.selected)
    )
  ) {
    isSelected = true;
  } else {
    dispatch(hideWaitingCover());
    dispatch(
      showMessageBox({
        show: true,
        message: "Please make a selection in the imprint location options.",
      })
    );
  }
  return isSelected;
};
